// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vnbdvcbLnVYsB_b_V61o{background:var(--background-primary-inverted-primary);border-radius:32px;width:254px;height:486px;padding:8px;display:flex;box-shadow:inset 0 -2px 12px rgba(169,180,188,.6)}.NZRJt8WVnD095zSHOw2U{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:32px;flex-grow:1;display:flex;overflow:hidden}.ERVpq7SOPb05jIkuG1n9{border-radius:12px;flex-grow:1;display:flex;overflow:auto}.VfkuqcCsvwsqm3nlx6Oq{flex-direction:column;gap:8px;display:flex}.SA2PMvpqfo2dgtxn8JQH{justify-content:flex-start;align-items:center;gap:6px;height:44px;display:flex}.t3VtXGwv0UMS0ph6Ri6I{padding:0 12px;box-shadow:0 1px 2px rgba(18,21,23,.12)}.PQu2brxD9K02w79uVMl4{flex-direction:column;gap:8px;padding:12px;display:flex}.vN4aUV9NgLQjDSAg7lu5{background:var(--background-brand-subtle-primary);color:var(--content-neutral-primary);border-radius:12px;max-width:200px;padding:12px}.eZB1J4FGbkkZJqWNdKL3{background:var(--background-neutral-default)}.P04UREefIjUpAaL5Q59v{width:186px;height:auto;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `vnbdvcbLnVYsB_b_V61o`,
	"preview__layer": `NZRJt8WVnD095zSHOw2U`,
	"previewLayer": `NZRJt8WVnD095zSHOw2U`,
	"preview__layerWrap": `ERVpq7SOPb05jIkuG1n9`,
	"previewLayerWrap": `ERVpq7SOPb05jIkuG1n9`,
	"preview__content": `VfkuqcCsvwsqm3nlx6Oq`,
	"previewContent": `VfkuqcCsvwsqm3nlx6Oq`,
	"preview__header": `SA2PMvpqfo2dgtxn8JQH`,
	"previewHeader": `SA2PMvpqfo2dgtxn8JQH`,
	"preview__headerWrap": `t3VtXGwv0UMS0ph6Ri6I`,
	"previewHeaderWrap": `t3VtXGwv0UMS0ph6Ri6I`,
	"preview__messages": `PQu2brxD9K02w79uVMl4`,
	"previewMessages": `PQu2brxD9K02w79uVMl4`,
	"preview__message": `vN4aUV9NgLQjDSAg7lu5`,
	"previewMessage": `vN4aUV9NgLQjDSAg7lu5`,
	"preview__messageOutbound": `eZB1J4FGbkkZJqWNdKL3`,
	"previewMessageOutbound": `eZB1J4FGbkkZJqWNdKL3`,
	"preview__messageWithImage": `P04UREefIjUpAaL5Q59v`,
	"previewMessageWithImage": `P04UREefIjUpAaL5Q59v`
};
export default ___CSS_LOADER_EXPORT___;
